import { connect } from 'react-redux';
import DateFormat from 'constants/date_format';

const AutoSaveIndicator = ({ lastUpdatedAt }) => {
  if (!lastUpdatedAt) {
    return null;
  }
  const date = moment(lastUpdatedAt);
  const dateFormatted = date.format(DateFormat.MONTH_DAY_YEAR_SHORT);
  const time = date.format(DateFormat.TIME);
  return `(${t('drafts.auto_saved')} ${dateFormatted} at ${time})`;
};

const mapStateToProps = state => ({
  isSaving: state.editor.isSaving,
  lastUpdatedAt: state.editor.lastUpdatedAt,
});

export default connect(mapStateToProps)(AutoSaveIndicator);
